import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import styled from "styled-components";

interface SystemMessageProps {
  title?: string;
  body?: string;
}

export const SystemMessage: React.FC<SystemMessageProps> = ({ title, body }) => {
  return (
    <Container>
      <IconContainer>
        <FontAwesomeIcon icon={faInfoCircle} fontSize="16px" color="#fff" />
      </IconContainer>
      <Content>
        {title && (
          <Typography variant="body_small" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        )}
        {body && <Typography variant="body_small">{body}</Typography>}
      </Content>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.redesign.db10};
  overflow: hidden;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.redesign.db90};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
`;
